export const SELECTED_ROAD_KEY = 'selectedRoad';
export const AVAILABLE_ROADS_KEY = 'availableRoads';
